/**
 * UX12: startsidan. Den som är inloggad och har en egen jaktmark (utöver demomarken; importerade marker som
 * dolts via IM2 kommer inte med i myMarks) startar på Min jakt. Djuplänkar (inbjudan, ?join=, ?labelId=,
 * /jakt/:slug, /annons/…, Stripe, notiser) vinner: bara en ren start på "/" byter flik.
 * Beslutet kommer ihåg lokalt, så att Min jakt visas direkt vid nästa start i stället för att blinka förbi Mer jakt.
 */
const KEY = 'qvenari_start_minajakt';

/** En start utan djuplänk: sökvägen "/" utan parametrar. */
export function isPlainStart(pathname: string, search: string): boolean {
  return (pathname === '/' || pathname === '') && (search === '' || search === '?');
}

/** Minst en mark som inte är demomarken. */
export function hasOwnMarks<M>(marks: M[] | null | undefined, isDemo: (m: M) => boolean): boolean {
  return !!marks && marks.some((m) => !isDemo(m));
}

/** Per person (Qid-sub), så att en annan inloggning på samma enhet inte ärver beslutet. */
export function rememberedMinJakt(sub: string | null | undefined): boolean {
  if (!sub) return false;
  try { return localStorage.getItem(KEY) === sub; } catch { return false; }
}

export function rememberMinJakt(sub: string | null | undefined, on: boolean) {
  try { if (on && sub) localStorage.setItem(KEY, sub); else localStorage.removeItem(KEY); } catch { /* privat läge */ }
}

/** Fliken som visas först, innan myMarks har svarat. */
export function initialMpTab(plain: boolean, loggedIn: boolean, remembered: boolean): 'minajakt' | 'jakt' {
  return plain && loggedIn && remembered ? 'minajakt' : 'jakt';
}
